import React from 'react'
import EditDefaultInput from '../EditDefaultInput'
import EditDefaultDate from './EditDefaultDate'
import EditDefaultTime from './EditDefaultTime'
import EditDefaultInputNumber from '../EditDefaultInputNumber'

type EditDefaultValueProps = {
  index: number
  element: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

export default function EditDefaultValue(props: EditDefaultValueProps) {
  const { index, element, currentElementState, setCurrentElementState } = props

  if (
    currentElementState['form_field_type'] === 'INPUT_CHECKBOX' ||
    currentElementState['form_field_type'] === 'INPUT_SELECT'
  ) {
    return null
  }

  if (
    currentElementState['form_field_type'] === 'INPUT_DATE' ||
    currentElementState['form_field_type'] === 'INPUT_DATETIME-LOCAL'
  ) {
    return (
      <EditDefaultDate
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
        element={element}
        index={index}
      />
    )
  }

  if (currentElementState['form_field_type'] === 'INPUT_TIME') {
    return (
      <EditDefaultTime
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
        element={element}
        index={index}
      />
    )
  }

  if (currentElementState['form_field_type'] === 'INPUT_NUMBER') {
    return (
      <EditDefaultInputNumber
        currentElementState={currentElementState}
        setCurrentElementState={setCurrentElementState}
        element={element}
        index={index}
      />
    )
  }

  return (
    <EditDefaultInput
      currentElementState={currentElementState}
      setCurrentElementState={setCurrentElementState}
      element={element}
      index={index}
    />
  )
}
